import React from "react";
import TooltipIcons from "../../../core/common/tooltip-content/tooltipIcons";
import RefreshIcon from "../../../core/common/tooltip-content/refresh";
import CollapesIcon from "../../../core/common/tooltip-content/collapes";
import { Link } from "react-router-dom";
import Table from "../../../core/pagination/datatable";
import useStore from "../../../store/store";
import BillingServices from "../../../services/BillingServices";
import useAsync from "../../../hooks/useAsync";
import {
  Download,
  Eye,
  PlusCircle,
  Trash2,
} from "feather-icons-react/build/IconComponents";
import OnlineorderModal from "./onlineorderModal";
import CommonDeleteModal from "../../../core/common/modal/commonDeleteModal";
import CommonFooter from "../../../core/common/footer/commonFooter";
import { BRAND_INFO } from "../../../utils/constants";

const OnlineOrder = () => {
  const user = useStore((state) => state.user);
  const selectedStore = useStore((state) => state.selectedStore);
  const storeId = selectedStore?._id;

  const { data: bills, loading } = useAsync(() => {
    const fetchBills = async () => {
      if (!storeId) {
        return []; // Return empty array if no store selected
      }
      const response = await BillingServices.getAllBillings(storeId);
      return response;
    };
    return fetchBills();
  }, [storeId]);

  // Transform bills data for the table
  const dataSource = bills.map((bill) => ({
    id: bill._id,
    customer: bill.customer.name,
    customerPhone: bill.customer.phone,
    reference: bill.billNumber,
    date: new Date(bill.date).toLocaleDateString(),
    total: `₹${bill.grossTotal.toFixed(2)}`,
    paid: `₹${bill.netPayable.toFixed(2)}`,
    paymentstatus:
      bill.status === "paid"
        ? "Paid"
        : bill.status === "pending"
        ? "Pending"
        : "Cancelled",
    customerImage: bill.customer.image || "default.png",
  }));

  const getWhatsAppInvoiceLink = (record) => {
    const baseUrl = "https://api.whatsapp.com/send?phone=";
    const phoneNumber = record.customerPhone;
    const invoiceUrl = `${BRAND_INFO.website}/customer-invoice/${record.id}`; // Replace with your actual invoice URL
    const message = `Hello ${record.customer},\n\nHere is your invoice:\n\nReference: ${record.reference}\nDate: ${record.date}\nTotal: ${record.paid}\n\nDownload invoice: ${invoiceUrl}\n\nThank you!`;
    const encodedMessage = encodeURIComponent(message);
    const whatsappLink = `${baseUrl}${phoneNumber}&text=${encodedMessage}`;
    window.open(whatsappLink, "_blank");
  };
  const handleSendTextMessage = (record) => {
    const phoneNumber = record.customerPhone;
    const message = `Hello ${record.customer},\n\nHere is your invoice:\n\nReference: ${record.reference}\nDate: ${record.date}\nTotal: ${record.total}\n\nThank you!`;
    alert(`Sending message to ${phoneNumber}:\n\n${message}`);
    // Here you can implement the logic to send the message using your preferred method (e.g., SMS API, email, etc.)
  };

  const columns = [
    {
      title: "Customer Name",
      dataIndex: "customer",
      render: (text) => <Link to="#">{text}</Link>,
      sorter: (a, b) => a.customer.length - b.customer.length,
    },
    {
      title: "Reference",
      dataIndex: "reference",
      sorter: (a, b) => a.reference.length - b.reference.length,
    },
    {
      title: "Date",
      dataIndex: "date",
      sorter: (a, b) => a.date.length - b.date.length,
    },
    {
      title: "Amount",
      dataIndex: "paid",
      sorter: (a, b) => a.paid.length - b.paid.length,
    },
    {
      title: "Payment Status",
      dataIndex: "paymentstatus",
      render: (render) => (
        <span
          className={`badge badge-xs shadow-none ${
            render === "Unpaid"
              ? "badge-soft-danger"
              : render === "Paid"
              ? "badge-soft-success"
              : "badge-soft-warning"
          } `}
        >
          <i className="ti ti-point-filled me-1"></i>
          {render}
        </span>
      ),
      sorter: (a, b) => a.paymentstatus.length - b.paymentstatus.length,
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_, record) => (
        <div className="d-flex align-items-center justify-content-between">
          <button
            className="btn btn-sm btn-success"
            onClick={() => getWhatsAppInvoiceLink(record)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa-brands fa-whatsapp" aria-hidden="true"></i>
          </button>
          <button
            className="btn btn-sm btn-secondary"
            onClick={() => handleSendTextMessage(record)}
          >
            <i className="fa-solid fa-envelope"></i>
          </button>
          <Link
            to={{
              pathname: `/invoice-details/${record.id}`,
              state: { billData: record },
            }}
            className="btn btn-sm btn-warning"
          >
            <i className="fa-solid fa-eye"></i>
          </Link>
        </div>
      ),
      sorter: (a, b) => a.createdby.length - b.createdby.length,
    },

    {
      title: "",
      dataIndex: "action",
      render: (_, record) => (
        <>
          <Link
            className="action-set"
            to="#"
            data-bs-toggle="dropdown"
            aria-expanded="true"
          >
            <i className="fa fa-ellipsis-v" aria-hidden="true" />
          </Link>
          <ul className="dropdown-menu">
            <li>
              <Link
                to={{
                  pathname: `/invoice-details/${record.id}`,
                  state: { billData: record },
                }}
                className="dropdown-item"
              >
                <Eye className="info-img" />
                Sale Detail
              </Link>
            </li>
            <li>
              <Link to="/add-sales" className="dropdown-item">
                <PlusCircle className="info-img" />
                Create Sales
              </Link>
            </li>
            <li>
              <Link
                to={{
                  pathname: `/invoice-details/${record.id}`,
                  search: "?action=download",
                }}
                className="dropdown-item"
                
              >
                <Download className="info-img" />
                Download pdf
              </Link>
            </li>
            {(user?.role === "super_admin" || user?.role === "franchise_owner") && (
              <li>
                <Link
                  to="#"
                  className="dropdown-item mb-0"
                  data-bs-toggle="modal"
                data-bs-target="#delete-modal"
              >
                <Trash2 className="info-img" />
                Delete Sale
              </Link>
            </li>
          )}
          </ul>
        </>
      ),
      sorter: (a, b) => a.createdby.length - b.createdby.length,
    },
  ];

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Sales</h4>
                <h6>Manage Your Sales</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <TooltipIcons />
              <RefreshIcon />
              <CollapesIcon />
            </ul>
            <div className="page-btn">
              <Link to="/add-sales" className="btn btn-primary">
                <i className="ti ti-circle-plus me-1"></i> Add Sales
              </Link>
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card manage-stock">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set"></div>
              <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-2">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Customer
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Carl Evans
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Minerva Rameriz
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Robert Lamon
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Patricia Lewis
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown me-2">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Staus
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Completed
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Pending
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown me-2">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Payment Status
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Paid
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Unpaid
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Overdue
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Sort By : Last 7 Days
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Desending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="custom-datatable-filter table-responsive">
                {!loading && (
                  <Table columns={columns} dataSource={dataSource} />
                )}
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
        <CommonFooter />
      </div>
      <OnlineorderModal />
      <CommonDeleteModal />
    </div>
  );
};

export default OnlineOrder;
